import { createSlice } from '@reduxjs/toolkit';
import { IProfile, IStudent } from '~/utils/interface/profile';
import { getProfile, getStudents, updateProfile } from './userThunk';
import { RootState } from '~/utils/redux/store';
import { IListDataResponseCanvas } from '~/utils/interface/base';
import { StorageEnum } from '~/utils/enum/base';

interface userState {
  profile: IProfile | null;
  isLoading: boolean;
  isRefresh: boolean;
  errorMessage?: string;
  students: IListDataResponseCanvas<IStudent[]> | null;
}

const initialState: userState = {
  profile: null,
  isRefresh: false,
  isLoading: false,
  students: null,
};

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    setRefresh(state, action) {
      state.isRefresh = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = undefined;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        localStorage.setItem(StorageEnum.CANVAS_ACCOUNT_ID, action.payload.data.id ?? '');
        state.profile = action.payload.data;
        state.isLoading = false;
        state.errorMessage = undefined;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.isLoading = false;
        state.errorMessage = action.error.message;
      });

    // Update profile
    builder
      .addCase(updateProfile.pending, (state) => {})
      .addCase(updateProfile.fulfilled, (state, action) => {})
      .addCase(updateProfile.rejected, (state, action) => {});

    // Get students
    builder
      .addCase(getStudents.pending, (state) => {})
      .addCase(getStudents.fulfilled, (state, action) => {
        state.students = action.payload.data;
      })
      .addCase(getStudents.rejected, (state, action) => {});
  },
});

// Actions
export const userActions = userSlice.actions;

// Selectors
export const selectIsRefresh = (state: RootState) => state.userState.isRefresh;
export const selectStudents = (state: RootState) => state.userState.students;

// Reducer
const userReducer = userSlice.reducer;
export default userReducer;
